import useStyles from "./styles";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import AllReports from "./componentes/allReports";
import { Box } from "@mui/system";
import GenerateReportWrapper from "./componentes/generateReportWrapper";
import api from "../../../services/api";
import VirtualizedAutocomplete from "../../../components/virtualization/virtualizedAutocomplete";
import {
	CampoCliente,
	renderOpcaoCliente,
} from "../../../components/opcaoCliente";
import { getClienteOptionLabel } from "../../../components/grupoEconomico/helpers";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Clear } from "@mui/icons-material";
import { Alert, Snackbar, TextField } from "@mui/material";
import TopBarFilter from "../../../components/topBarFilter";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import ButtonTime from "../../../components/buttonTime";
import minMax from "dayjs/plugin/minMax";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

dayjs.extend(minMax);
dayjs.extend(isSameOrBefore);

export default function RelatorioView() {
	const theme = useTheme();
	const styles = useStyles(theme);
	const [componentValue, setComponentValue] = useState(0);
	const [reportToEdit, setReportToEdit] = useState(null);
	const [allHostsCliente, setAllHostsCliente] = useState({ cpe: [], onu: [] });
	const [loadingHostClient, setLoadingHostClient] = useState(false);

	const [loadingInterface, setLoadingInterface] = useState(false);

	const [selectedCliente, setSelectedCliente] = useState(null);
	const [clientes, setClientes] = useState([]);
	const [usuarios, setUsuarios] = useState([]);
	const [selectedUsuario, setSelectedUsuario] = useState(null);
	const [loadingUsuarios, setLoadingUsuarios] = useState(true);
	const [windowWith, setWindowWith] = useState(window.innerWidth);

	const isAdmin = React.useMemo(() => {
		const userStorage = JSON.parse(localStorage.getItem("user"));
		if (Array.isArray(userStorage?.usuario?.rlPermissoesUsuario)) {
			return userStorage.usuario.rlPermissoesUsuario.some(
				(permissao) => permissao?.permissao?.codigoPermissao?.toUpperCase() === "ADM"
			);
		}
		return false;
	}, []);
	const id = useParams();
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const [snackbar, setSnackbar] = useState(null);
	const { controllerDashboard, setControllerDashboard } = useOutletContext();

	// ==========================================
	// ESTADOS E LÓGICA DO BUTTON TIME
	// ==========================================
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const [selectTime, setSelectTime] = useState(null);
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [isValidRange, setIsValidRange] = useState(false);
	const [filterData, setFilterData] = useState({
		initialDate: null,
		finalDate: null,
	});

	const optionsTime = {
		0: {
			value: dayjs().startOf("day").toDate(),
			label: "Hoje",
		},
		1: {
			value: dayjs().subtract(7, "day").toDate(),
			label: "Últimos 7 dias",
		},
		2: {
			value: dayjs().subtract(15, "day").toDate(),
			label: "Últimos 15 dias",
		},
		3: {
			value: dayjs().subtract(30, "day").toDate(),
			label: "Últimos 30 dias",
		},
		4: {
			value: dayjs().subtract(3, "month").toDate(),
			label: "Últimos 3 meses",
		},
		5: {
			value: dayjs().subtract(6, "month").toDate(),
			label: "Últimos 6 meses",
		},
	};

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleStartChange = (newValue) => {
		setStartDate(newValue);
		if (newValue?.isAfter(endDate)) {
			setEndDate(newValue);
		}
	};

	const handleEndChange = (newValue) => {
		setEndDate(newValue);
	};

	const handleAplicar = () => {
		const dateStrStart = startDate ? startDate.format("YYYY-MM-DD") : "";
		const dateStrEnd = endDate ? endDate.format("YYYY-MM-DD") : "";

		setFilterData((prev) => ({
			...prev,
			initialDate: startDate?.toDate() || null,
			finalDate: endDate?.toDate() || null,
		}));

		const currentStorage = JSON.parse(localStorage.getItem("filterData")) || {};
		localStorage.setItem(
			"filterData",
			JSON.stringify({
				...currentStorage,
				initialDate: dateStrStart,
				finalDate: dateStrEnd,
				selectTime: null,
				date: "",
			}),
		);
		setSelectTime(null);
		handleClose();
	};

	const handleSelectTime = (key) => {
		setSelectTime(key);
		setStartDate(null);
		setEndDate(null);
		handleClose();

		const initD = optionsTime[key]?.value;
		const endD = dayjs().toDate();

		setFilterData((prev) => ({
			...prev,
			initialDate: initD,
			finalDate: endD,
		}));

		const dateStrStart = dayjs(initD).format("YYYY-MM-DD");
		const dateStrEnd = dayjs(endD).format("YYYY-MM-DD");

		const currentStorage = JSON.parse(localStorage.getItem("filterData")) || {};
		localStorage.setItem(
			"filterData",
			JSON.stringify({
				...currentStorage,
				initialDate: dateStrStart,
				finalDate: dateStrEnd,
				selectTime: key,
				date: "",
			}),
		);
	};

	useEffect(() => {
		const now = dayjs();
		setIsValidRange(
			dayjs.isDayjs(startDate) &&
				dayjs.isDayjs(endDate) &&
				startDate.isValid() &&
				endDate.isValid() &&
				!startDate.isAfter(endDate) &&
				!endDate.isBefore(startDate) &&
				!startDate.isAfter(now) &&
				!endDate.isAfter(now),
		);
	}, [endDate, startDate]);
	// ==========================================

	async function apiGetClientes() {
		setLoading(true);
		if (controllerDashboard) {
			controllerDashboard.abort();
		}
		const newController = new AbortController();
		const signal = newController.signal;
		setControllerDashboard(newController);
		try {
			const response = await api.get("/interno/getClients", { signal });

			setClientes(response.data);

			const clienteEncontrado = response?.data?.find(
				(cliente) => cliente?.id === id?.id,
			);

			if (clienteEncontrado) {
				setSelectedCliente(clienteEncontrado || null);

				const clientStorage = {
					interfaceId: "",
					clienteId: clienteEncontrado?.id,
					hostId: "",
					selectTime: 5,
					initialDate: "",
					finalDate: "",
				};

				localStorage.setItem("filterData", JSON.stringify(clientStorage));
				setSelectTime(5);
				return;
			}

			// Não pré-seleciona mais o cliente por padrão.
			setSelectedCliente(null);
			setSelectTime(5);
			const initD = optionsTime[5]?.value;
			const endD = dayjs().toDate();
			setFilterData({
				initialDate: initD,
				finalDate: endD,
			});
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	}

	async function apiGetUsuarios() {
		try {
			setLoadingUsuarios(true);
			const userStorage = JSON.parse(localStorage.getItem("user"));
			const loggedInUserId = userStorage?.usuario?.id;

			if (!isAdmin) {
				if (userStorage?.usuario) {
					setSelectedUsuario(userStorage.usuario);
				}
				return;
			}

			const response = await api.get("/interno/relatorio/users");
			setUsuarios(response?.data || []);

			if (loggedInUserId) {
				const loggedInUser = response?.data?.find(
					(u) => u?.id === loggedInUserId
				);
				if (loggedInUser) {
					setSelectedUsuario(loggedInUser);
				}
			}
		} catch (error) {
			console.error("Erro ao buscar usuários:", error);
		} finally {
			setLoadingUsuarios(false);
		}
	}

	// BUSCA TODOS OS HOST DO CLIENTE
	const getAllHostClient = async () => {
		setLoadingHostClient(true);
		try {
			const response = await api.post("/interno/findMany/hostsCliente", {
				clienteId: selectedCliente?.id,
				mapHostsByEquipmentType: true,
			});
			setAllHostsCliente(
				response?.data
					? {
							cpe: response?.data?.cpes || [],
							onu: response?.data?.onus || [],
						}
					: {
							cpe: [],
							onu: [],
						},
			);
		} catch (error) {
			console.error("Erro ao buscar hosts do cliente:", error);
			setAllHostsCliente({
				cpe: [],
				onu: [],
			});
		} finally {
			setLoadingHostClient(false);
		}
	};

	const getInterface = async (hostId) => {
		try {
			setLoadingInterface(true);
			const response = await api.post("/zabbix/interfaceList", {
				hostId: hostId,
			});
			return response?.data || [];
		} catch (error) {
			console.error("Erro ao buscar interfaces:", error);
			return [];
		} finally {
			setLoadingInterface(false);
		}
	};

	useEffect(() => {
		apiGetClientes();
		apiGetUsuarios();

		const handleResize = () => {
			setWindowWith(window.innerWidth);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	useEffect(() => {
		if (selectedCliente?.id) {
			getAllHostClient();
		} else {
			setAllHostsCliente({ cpe: [], onu: [] });
		}
	}, [selectedCliente?.id]);

	return (
		<Box>
			<TopBarFilter
				selectorComponentLeft={
					<Box sx={{ display: "flex", gap: 1, width: "100%", maxWidth: 1000 }}>
						{/* Filtro de Usuário */}
						{isAdmin && (
							<VirtualizedAutocomplete
								sx={{
									width: "100%",
									maxWidth: 400,
								}}
								value={selectedUsuario}
								onChange={(_, newValue) => {
									setSelectedUsuario(newValue);
								}}
								clearIcon={
									<Clear
										onClick={() => {
											setSelectedUsuario(null);
										}}
									/>
								}
								size="small"
								options={usuarios}
								getOptionLabel={(option) => {
									if (!option) return "";
									const nomeCompleto = [option.nome, option.sobrenome].filter(Boolean).join(" ");
									return nomeCompleto || option.login || "";
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										label="Usuário"
										size="small"
										sx={styles.filterAutocomplete}
									/>
								)}
							/>
						)}

						{/* Filtro de Cliente */}
						{componentValue === 0 && (
							<VirtualizedAutocomplete
								sx={{
									width: "100%",
									maxWidth: 400,
								}}
								value={selectedCliente}
								onChange={(_, newValue) => {
									setSelectedCliente(newValue);
									if (newValue?.id) {
										const clientStorage = {
											interfaceId: "",
											clienteId: newValue?.id,
											hostId: "",
											selectTime: 5,
											initialDate: "",
											finalDate: "",
										};
										localStorage.setItem("filterData", JSON.stringify(clientStorage));
									} else {
										localStorage.removeItem("filterData");
									}
								}}
								clearIcon={
									<Clear
										fontSize="small"
										onClick={() => {
											localStorage.removeItem("filterData");
											setSelectedCliente(null);
										}}
									/>
								}
								size="small"
								options={clientes.filter(
									(cliente) => !cliente?.isGrupoEconomico
								)}
								getOptionLabel={(option) => getClienteOptionLabel(option)}
								renderOption={renderOpcaoCliente()}
								renderInput={(params) => (
									<CampoCliente
										params={params}
										option={selectedCliente}
										label="Cliente"
										sx={styles.filterAutocomplete}
									/>
								)}
							/>
						)}
					</Box>
				}
				selectorComponentRight={
					<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
						{componentValue === 0 && (
							<ButtonTime
								open={open}
								optionsTime={optionsTime}
								selectTime={selectTime}
								handleClick={handleClick}
								anchorEl={anchorEl}
								handleClose={handleClose}
								loading={false}
								handleStartChange={handleStartChange}
								handleEndChange={handleEndChange}
								handleAplicar={handleAplicar}
								isValidRange={isValidRange}
								endDate={endDate}
								startDate={startDate}
								setEndDate={setEndDate}
								setStartDate={setStartDate}
								setSelectTime={setSelectTime}
								handleSelectTime={handleSelectTime}
								filterData={filterData}
								DateTime={DatePicker}
								todayMaxDataTime={null}
							/>
						)}
					</Box>
				}
			/>

			{componentValue === 0 && (
				<AllReports
					setComponentValue={setComponentValue}
					clienteId={selectedCliente?.id}
					usuarioId={selectedUsuario?.id}
					loadingUsuarios={loadingUsuarios}
					setSnackbar={setSnackbar}
					initialDate={filterData?.initialDate}
					finalDate={filterData?.finalDate}
					onEditReport={(report) => {
						setReportToEdit(report);
						const matchCliente = clientes.find((c) => c.id === report.clienteId);
						if (matchCliente) {
							setSelectedCliente(matchCliente);
						}
						setComponentValue(2);
					}}
				/>
			)}

			{(componentValue === 1 || componentValue === 2) && (
				<GenerateReportWrapper
					key={selectedCliente?.id}
					setComponentValue={(val) => {
						if (val === 0) setReportToEdit(null);
						setComponentValue(val);
					}}
					reportToEdit={reportToEdit}
					theme={theme}
					styles={styles}
					allHostsCliente={[
						...(allHostsCliente?.cpe ?? []),
						...(allHostsCliente?.onu ?? []),
					]}
					loadingHostClient={loadingHostClient}
					getInterface={getInterface}
					loadingInterface={loadingInterface}
					api={api}
					clienteInfo={selectedCliente}
					selectedCliente={selectedCliente}
					setSelectedCliente={setSelectedCliente}
					clientes={clientes}
					setSnackbar={setSnackbar}
				/>
			)}
			<Snackbar
				open={!!snackbar}
				onClose={() => setSnackbar(null)}
				autoHideDuration={2500}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
			>
				<Alert {...snackbar} onClose={() => setSnackbar(null)} />
			</Snackbar>
		</Box>
	);
}
